import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms'
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { LearnerService } from '../../services/learner.service'
import { UserRoleService } from '../../services/user-role.service';
import { isLeapYear } from 'date-fns';
import { findIndex } from 'rxjs/operators';
import { element } from 'protractor';
import * as _ from 'lodash';
import { CourseSignaturePadComponent } from '../course-signature-pad/course-signature-pad.component';
@Component({
  selector: 'app-assessment-plan-level3',
  templateUrl: './assessment-plan-level3.component.html',
  styleUrls: ['./assessment-plan-level3.component.scss']
})
export class AssessmentPlanLevel3Component implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  currentUser
  isIQA: boolean = false;

  constructor(
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _learnerService: LearnerService,
    public _userRoleService: UserRoleService

  ) { }
  learnerData
  jobData
  planFormedit
  learnerName
  assmentForm: any
  assessorSign1: boolean
  learnerSign1: boolean = false
  loading = false
  user
  admin
  isLearner: boolean = false
  isAdmin: boolean = false
  isTrainer: boolean = false
  learnerpointer = "auto"

  ngOnInit() {
    // else if (this.user.isMp || this.user.isTrainer || this.user.isIQA || this.user.isOperative) {
    //   console.log("this.isLearner", this.user.isMp);
    //   this.isTrainer = true
    // }
    // else
    //   this.isTrainer = true

    // this.assetmentFormCreate()
  }

  ngOnChanges(changes: SimpleChanges): void {


    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue[0]
      this.getUserRole();
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.planFormedit = changes.assessmentEdit.currentValue
      console.log("edit form value", this.planFormedit);
      let size = Object.keys(this.planFormedit).length;
      console.log("what is the size of object", size);

      if (size != 0) {


        if (this.planFormedit && this.planFormedit.assetmentLevel3Form) {
          if (this.planFormedit.assetmentLevel3Form && this.planFormedit.assetmentLevel3Form.assessorSign != "") {
            this.assessorSign1 = true
          }
          if (this.planFormedit.assetmentLevel3Form && this.planFormedit.assetmentLevel3Form.learnerSign != "") {
            this.learnerSign1 = true
          }
        }

        this.assetmentFormCreate(this.planFormedit)

      }
    }
    else {
      this.assetmentFormCreate()
    }

    if (changes.singleLearner && changes.singleLearner.currentValue && changes.singleLearner.currentValue != undefined) {
      this.learnerData = changes.singleLearner.currentValue
      console.log("learner data ============>", this.learnerData)
      this.learnerName = this.learnerData.name
      console.log("which user ============>", this.learnerData.userType)
      // this.user = this.learnerData.userType
      // if (this.user == "learner") {
      //   this.isLearner = true
      // }
      // console.log("this.user======>", this.user, "this.isLearner===>", this.isLearner);
      console.log("this learner name======>", this.learnerName)
      this.assetmentFormCreate(this.planFormedit)
    }
    // this.formCreate()
  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.jobData.instructors, 'job');
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true

  }
  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }

  addSignature(fomrControl) {
    if ((this.isLearner || this.isIQA) && fomrControl == 'assessorSign') {
      this.assmentForm.get('assessorSign').disable()
      // this.handleSnackBar({ msg: "You have no rights to add assessor sign!", button: "Ok" });
    }
    else if ((this.isTrainer || this.isIQA) && fomrControl == 'learnerSign') {
      this.assmentForm.get('learnerSign').disable()
      // this.handleSnackBar({ msg: "You have no rights to add assessor sign!", button: "Ok" });
    }
    else {
      this.openDialog(CourseSignaturePadComponent).subscribe((data) => {
        console.log("data of sign", data);
        if (data == undefined) return

        let sign = data

        // if (formType == 'trackMaintenance') {

        if (fomrControl == 'assessorSign') {
          this.assessorSign1 = true
          this.assmentForm.patchValue({
            assessorSign: sign
          })
        }
        if (fomrControl == 'learnerSign') {
          this.learnerSign1 = true
          this.assmentForm.patchValue({
            learnerSign: sign
          })
        }
      })
    }
  }

  assetmentFormCreate(details?) {
    console.log("Details for assement plan form", details)
    this.assmentForm = new FormGroup({
      qualification: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.qualification : ''),
      // units: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation1 : ''),
      assessmentcenter: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.assessmentcenter : ''),
      assessmentLocationTheory: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.assessmentLocationTheory : ''),
      assessmentLocationPractical: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.assessmentLocationPractical : ''),
      date: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.date : ''),
      observation1: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation1 : ''),
      observation2: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation2 : ''),
      observation3: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation3 : ''),
      observation4: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation4 : ''),
      observation5: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation5 : ''),
      observation6: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation6 : ''),
      observation7: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation7 : ''),
      observation8: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation8 : ''),
      observation9: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation9 : ''),
      observation10: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.observation10 : ''),
      comment: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.comment : ''),
      assessorname: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.assessorname : ''),
      assessorSign: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.assessorSign : ''),
      learnername: new FormControl((details && details.assetmentLevel3Form && details.assetmentLevel3Form.learnername && details.assetmentLevel3Form.learnername !== null) ? details.assetmentLevel3Form.learnername : this.learnerName),
      learnerSign: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.learnerSign : ''),
      date2: new FormControl((details && details.assetmentLevel3Form) ? details.assetmentLevel3Form.date2 : '')
    })

    // if (this.isAdmin) {
    //   this.assmentForm.enable()
    // }
    // if (this.isTrainer) {
    //   this.assmentForm.get('learnername').disable()
    // }
    // if (this.isLearner) {
    //   this.assmentForm.get('observation1').disable()
    //   this.assmentForm.get('observation2').disable()
    //   this.assmentForm.get('observation3').disable()
    //   this.assmentForm.get('observation4').disable()
    //   this.assmentForm.get('observation5').disable()
    //   this.assmentForm.get('observation6').disable()
    //   this.assmentForm.get('observation7').disable()
    //   this.assmentForm.get('observation8').disable()
    //   this.assmentForm.get('observation9').disable()
    //   this.assmentForm.get('observation10').disable()
    //   this.assmentForm.get('comment').disable()
    //   this.assmentForm.get('assessorname').disable()
    // }



  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'assmentForm')
      this.assmentForm.get(formControl).setValue(value);

  }

  assementPlanFormSubmit() {
    console.log("assetment Form Data ===========>", this.assmentForm.value);
    let data = {
      learnerId: this.learnerData._id,
      jobId: this.jobData._id,
      version: true,
      details: {
        assetmentLevel3Form: this.assmentForm.value,
      },
      // type: 'assementPlan'
    }
    this.loading = true
    console.log("this._learnerService.submitPolicy(data) in assessmant Plan", data)
    this._learnerService.submitPolicy(data).subscribe(res => {
      console.log('Policy res', res);
      this.handleSnackBar({ msg: "Data submitted successfully!", button: "Ok" });
      this.loading = false
    }, (err) => {
      this.loading = false
      console.log("Assessment Plan not accepted", err)
    })

  }

}
